export default "__VITE_ASSET__DlYnbtbl__"